import React, { createContext, ReactNode, useContext, useState } from "react";
import Recaptcha from "react-recaptcha";
import secureLocalStorage from "react-secure-storage";

type RecaptchaFieldContextProps = {
    setCaptchaRef: React.Dispatch<Recaptcha | null>
    reset: () => void
    captchaRef: Recaptcha | null
}

type RecaptchaFieldProviderProps = {
    children: ReactNode
}

const RecaptchaFieldContext = createContext<RecaptchaFieldContextProps>({} as RecaptchaFieldContextProps)

export const RecaptchaFieldProvider = ({ children }: RecaptchaFieldProviderProps) => {
    const [captchaRef, setCaptchaRef] = useState<Recaptcha | null>(null)

    const reset = () => {
        if (!!captchaRef) {
            captchaRef.reset()
        }
        secureLocalStorage.removeItem('@grecaptcha')
    };

    return (
        <RecaptchaFieldContext.Provider value={{setCaptchaRef, reset, captchaRef}}>
            {children}
        </RecaptchaFieldContext.Provider>
    )
}

export const useRecaptchaField = () => useContext(RecaptchaFieldContext);